import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./RecordPaymentForm";
import {cancelRecordPayment} from "../../actions/AccountApiActions";
import {showDatePicker} from "../../actions/ViewActions";
import {fromJS, Map} from "immutable";
import {validatePresence, validateGreaterThan} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "paymentMethod");
  errors = validateGreaterThan(errors, values, "amount", 0);
  errors = validatePresence(errors, values, "currency");
  errors = validatePresence(errors, values, "paymentDate");
  errors = validatePresence(errors, values, "transactionRef");
  return errors.toJS();
}

const paymentMethods = fromJS([
  {id: "check", title: "Check"},
  {id: "bank_transfer", title: "Bank Transfer"}
])

class RecordPaymentFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("accountId", this.props.accountId)
                              .set("salesOrderId", this.props.salesOrderId)
                              .set("amount", parseFloat(values.get("amount"), 10));
    return this.props.receivePayment(updatedValues.toJS())
      .then((response) => {
        if (response.data.receivePayment.errors.length <= 0) {
          this.props.cancelRecordPayment();
        } else {
          let errors = createValidationErrors(response.data.receivePayment.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelRecordPayment();
  }

  render() {
    // let {data} = this.props;
    // if (data.loading) return <Loading />
    // if (data.error) return <p>{data.error}</p> 
    return (
      <Form
        errors={this.state.errors}
        validate={validateForm}
        paymentMethods={paymentMethods}
        showDatePicker={this.props.showDatePicker}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const RECEIVE_PAYMENT = gql`
  mutation receivePayment($data: BillingPaymentTermsInput!) {
    receivePayment(input: $data) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(RECEIVE_PAYMENT, {
    props: ({ mutate }) => ({
      receivePayment: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);


export default connect(null, {cancelRecordPayment, showDatePicker})(withQueries(RecordPaymentFormContainer));